import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexCenter, HideScrollbar } from '../../../global/commonStyle';
import { tablet } from '../../../global/mediaQueryMixin';

interface Props {
  isActive?: boolean;
}
const ModalBox = styled.div`
  height: 570px;
  position: relative;
  .close-icon-sticky {
    position: absolute;
    top: 10px;
    z-index: var(--z-index-base);
    right: 10px;
  }
`;

const Content = styled.div`
  display: flex;
  height: 100%;
`;
const LeftContent = styled.div`
  max-width: 490px;
  width: 100%;
  padding: var(--space-40);
  border-right: 0.5px solid var(--border-primary);
  .docs-section {
    border: none;
    border-radius: var(--border-radius-4);
  }
  ${tablet(css`
    max-width: unset;
  `)}
`;

const RightContent = styled.div`
  max-width: 200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const BottomContent = styled.div`
  padding-block: var(--space-4) var(--space-0);
  height: 100%;
  ${HideScrollbar}
`;
const FirstHistory = styled.div`
  padding: var(--space-5) var(--space-16);
  ${AlignCenter}
  gap: var(--space-8);
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
  }
`;
const Text = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
const ArrowIcon = styled.div<Props>`
  ${FlexCenter}
  .rotated {
    transform: rotate(90deg);
  }
`;
const SubHistory = styled.div<Props>`
  padding: var(--space-6) var(--space-16);
  ${AlignCenter}
  gap: var(--space-8);
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--neutral-secondary);
    `};
`;
const Subtext = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
`;
const DotIcon = styled.div`
  width: 18px;
  ${FlexCenter}
  position: relative;
  z-index: var(--z-index-base);
`;
const Dot = styled.div<Props>`
  width: 6px;
  height: 6px;
  border-radius: var(--border-radius-full);
  background-color: var(--text-tertiary);
  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--brand-primary);
    `};
`;
const Line = styled.div`
  border-left: 0.5px solid var(--border-primary);
  height: 28px;
  top: 1px;
  position: absolute;
  z-index: var(--z-index-negative);
  left: 9px;
  ${SubHistory}:last-child & {
    border-left: none;
  }
`;
const Div = styled.div``;

const BottomTag = styled.div`
  max-width: 168px;
  position: sticky;
  border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-16) var(--border-radius-0);
  padding: var(--space-8) var(--space-16) var(--space-16);
  background-color: var(--background-primary);
  bottom: 0;
  z-index: var(--z-index-base);
  display: flex;
  justify-content: center;
`;
export {
  ModalBox,
  Content,
  LeftContent,
  RightContent,
  BottomContent,
  FirstHistory,
  Text,
  ArrowIcon,
  SubHistory,
  Subtext,
  DotIcon,
  Dot,
  Line,
  Div,
  BottomTag
};
